/**
 * Key used in tool output to identify artifact responses.
 * Tools that produce artifacts must wrap their output under this key to avoid
 * accidental matches when tool output contains generic keys like "data" or "artifactType".
 */
export const COTERA_ARTIFACT_KEY = '@@cotera-artifact' as const;

/** Keys for the inner artifact object (nested under COTERA_ARTIFACT_KEY). */
export const COTERA_ARTIFACT_TYPE_KEY = '@@cotera-artifact-type' as const;
export const COTERA_ARTIFACT_ID_KEY = '@@cotera-artifact-id' as const;
export const COTERA_ARTIFACT_DATA_KEY = '@@cotera-artifact-data' as const;
export const COTERA_ARTIFACT_ORIGIN_KEY = '@@cotera-artifact-origin' as const;

/**
 * What a tool call did to the artifact it is returning.
 *
 * Declared by the tool at the point it builds its response rather than inferred
 * from its key, because a list of "these keys create things" is a list somebody
 * has to remember to add to, kept in a different package from the tool it
 * describes, and silently wrong the day they forget. `artifactResponse` takes
 * this as a required argument instead, so a new artifact tool does not compile
 * until it has said which of the three it is.
 *
 * `opened` is a real answer, not a filler: `coco/open-workflow` puts a workflow
 * on screen without touching it, and the honest report for that is no verb at
 * all. Having to pick it is what stops `created` becoming the value you pass to
 * make the type error go away.
 */
export type ArtifactOrigin = 'created' | 'edited' | 'opened';
